import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {extractPathFromUrlString} from "./url-params-serializer";
import {InvalidEchoError} from "../errors/invalid-echo-error";
import {map} from "rxjs/operators";

@Injectable()
export class HttpClientSequencerInterceptor implements HttpInterceptor {
  private static indexes = {};

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.params || !req.params.has("sequence")) {
      return next.handle(req);
    }

    const key = extractPathFromUrlString(req.url);
    if (!HttpClientSequencerInterceptor.indexes[key]) HttpClientSequencerInterceptor.indexes[key] = 0;

    HttpClientSequencerInterceptor.indexes[key] += 1;
    const thisIndex = HttpClientSequencerInterceptor.indexes[key];

    return next.handle(req)
      .pipe(
        map((event: HttpEvent<any>) => {
          const currentIndex = HttpClientSequencerInterceptor.indexes[key];

          if (event.type === 4 && thisIndex < currentIndex) {
            throw new InvalidEchoError();
          }

          return event;
        }),
      );
  }
}

export const HttpClientSequencerInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpClientSequencerInterceptor,
  multi: true,
};
